import React from 'react';
import {
  DefaultCard,
  DefaultButton,
  DottedHr,
  colors,
  moneyFormat,
} from 'design-system';
import { Grid, Typography, makeStyles } from '@material-ui/core';

const { formatMoney } = moneyFormat;

const useStyles = makeStyles(() => ({
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  titleSection: { paddingBottom: 7 },
  textGray: {
    textTransform: 'capitalize',
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
  },
  priceText: {
    fontSize: 19,
    fontWeight: 900,
  },
  informationText: {
    fontSize: 13,
    fontWeight: 500,
  },
  divider: {
    marginTop: 25,
  },
}));

type Props = {
  customerName: string;
  vehicleData: string;
  numberOfPayments: number;
  total: number;
  currency: string;
  onShowQuotation: () => void;
};

const MobilePriceCard = ({
  customerName,
  vehicleData,
  numberOfPayments,
  total,
  currency,
  onShowQuotation,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <DefaultCard data-testid="mobile-price-card">
      <Grid item className={classes.titleSection}>
        <Typography className={classes.titleText} data-testid="customer-text">
          {customerName}
        </Typography>
      </Grid>

      <Grid item>
        <Typography className={classes.textGray} data-testid="vehicle-text">
          {vehicleData}
        </Typography>
      </Grid>

      <Grid item container>
        <Grid item xs={6} container alignItems="flex-end">
          <Typography className={classes.informationText}>
            Cobertura Completa
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Grid item container justifyContent="flex-end">
            <Typography
              className={classes.priceText}
              data-testid="payment-text"
            >
              {formatMoney(total / numberOfPayments, false, currency)}
            </Typography>
          </Grid>
          <Grid item container justifyContent="flex-end">
            <Typography
              className={classes.informationText}
              data-testid="number-payments-text"
            >{`${numberOfPayments} cuotas mensual`}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item className={classes.divider}>
        <DottedHr />
      </Grid>

      <Grid item>
        <DefaultButton
          data-testid="view-details-button"
          fullWidth
          variant="borderless"
          onClick={onShowQuotation}
        >
          ver cotización
        </DefaultButton>
      </Grid>
    </DefaultCard>
  );
};

export default MobilePriceCard;
